import { Switch } from '@headlessui/react';

const ToggleControl = ({ label, description, checked, onChange, className = '', disabled = false }) => {
  const containerClasses = ['flex items-center justify-between gap-4', className]
    .filter(Boolean)
    .join(' ');

  return (
    <Switch.Group as="div" className={containerClasses}>
      <div className="flex-1">
        <Switch.Label className="text-sm font-medium dark:text-customHeading text-background">{label}</Switch.Label>
        {description ? (
          <Switch.Description className="text-xs dark:text-customMuted text-primary">
            {description}
          </Switch.Description>
        ) : null}
      </div>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`${
          checked ? 'bg-customAccent' : 'bg-customSurfaceMuted'
        } relative inline-flex h-7 w-12 flex-shrink-0 items-center rounded-full border border-customBorder transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-customAccent focus-visible:ring-offset-2 focus-visible:ring-offset-settings-surface ${
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
        }`}
      >
        <span className="sr-only">Toggle {label}</span>
        <span
          aria-hidden="true"
          className={`${
            checked ? 'translate-x-6' : 'translate-x-1'
          } inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-200`}
        />
      </Switch>
    </Switch.Group>
  );
};

export default ToggleControl;
